export default __webpack_public_path__ + "static/media/memoji_new.777cac79.webp";